import { useSelector } from "react-redux";
import { useAppDispatch } from "hooks/hooks";
import Modal from "components/Modal/Modal";
import { toast } from "react-toastify";
import {
  deleteRequisition,
  deleteRequisitionById,
  selectRequisitionForDeletion,
  selectState,
  setDeleteRequisitionModalOpen
} from "../requisition.slice";
import { useEffect } from "react";

interface IProps {
  setClickOutsideActive: React.Dispatch<React.SetStateAction<boolean>>;
}

const DeleteRequisitionModal = (
  { setClickOutsideActive }: IProps
) => {
  const { deleteRequisitionModalOpen } = useSelector(selectState);
  const requisition = useSelector(selectRequisitionForDeletion);
  const dispatch = useAppDispatch();

  useEffect(() => {
    if (deleteRequisitionModalOpen) {
      setClickOutsideActive(false);
    }
  }, [deleteRequisitionModalOpen, setClickOutsideActive])

  const close = () => {
    setClickOutsideActive(true);
    dispatch(setDeleteRequisitionModalOpen({ visible: false, index: -1 }));
  };

  const doDelete = async () => {
    try {
      if (requisition) {
        await dispatch(deleteRequisition(requisition.requisitionId));
        dispatch(deleteRequisitionById(requisition.requisitionId));
        toast.success("Uspešno obrisano trebovanje.");
        close();
      } else {
        toast.warn("Brisanje trebovanja nije moguće");
        close();
      }
    } catch (err) {
      console.log(err);
    }
  };

  return (
    <Modal
      isOpen={deleteRequisitionModalOpen}
      onClick={doDelete}
      onClose={close}
      title="Brisanje trebovanja"
    >
      <p className="info-msg">
        Da li ste sigurni da želite da obrišete dato trebovanje?
        <br />
        <br />
      </p>
    </Modal>
  );
};

export default DeleteRequisitionModal;
